import { render, staticRenderFns } from "./ro.vue?vue&type=template&id=64e9d411&scoped=true"
import script from "./ro.vue?vue&type=script&lang=js"
export * from "./ro.vue?vue&type=script&lang=js"
import style0 from "./ro.vue?vue&type=style&index=0&id=64e9d411&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e9d411",
  null
  
)

export default component.exports